/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Modal, Button } from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import callAPI from '@/api/callAPI';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  showModal: PropTypes.bool.isRequired,
  checkedNodes: PropTypes.array.isRequired,
  onDelSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

class DeleteNodes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
      checkedNodes: props.checkedNodes,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.node.delete');
  }

  componentWillReceiveProps({ showModal, checkedNodes }) {
    if (showModal !== this.props.showModal) {
      this.setState({ showModal });
    }
    if (!_.isEqual(checkedNodes, this.props.checkedNodes)) {
      this.setState({ checkedNodes });
    }
  }

  onSubmite() {
    this.setState({ delStatus: 'pending' });

    const { checkedNodes } = this.state;
    const copyNodes = _.cloneDeep(checkedNodes);
    const delFunc = () => {
      const node = copyNodes.pop();
      if (node) {
        callAPI({
          endpoint: `/tdmng/nodes/${node}`,
          method: 'DELETE',
        }).then(() => {
          delFunc();
        }).catch(() => {});
      } else {
        this.setState({ delStatus: 'success' });

        _.delay(() => {
          this.props.onDelSuccess();
          this.props.onCancel();
        }, 250);
      }
    };
    delFunc();
  }

  render() {
    const { showModal, delStatus } = this.state;

    return (
      <Modal
        bsClass="aisz-modal-danger"
        backdrop="static"
        show={showModal}
        onHide={this.props.onCancel}
      >
        <Modal.Header closeButton>
          {this.intlMsg.msg('title')}
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">{this.intlMsg.msg('warn')}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="aisz-default"
            className={styles.white}
            onClick={() => this.props.onCancel()}
          >
            {this.intlMsg.msg('cancel')}
          </Button>
          <Button
            bsStyle="aisz-danger"
            onClick={() => this.onSubmite()}
            disabled={delStatus === 'pending'}
          >
            {delStatus === 'pending' && <i className="fa fa-spin fa-spinner m-r-s" />}
            {this.intlMsg.msg('confirm')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

DeleteNodes.propTypes = propTypes;

export default injectIntl(DeleteNodes);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/Node/DeleteNodes.jsx